import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import { initLayout } from '../layout.js';
import { initPageHeader } from '../sections/page-header.js';
import { initProductionSiteMap } from '../sections/production-site-map.js';


document.addEventListener('DOMContentLoaded', () => {
    initLayout();
    initPageHeader();
    initProductionSiteMap();
    initProductionSiteListing();
})


function initProductionSiteListing(){
    document.querySelectorAll('.card-production-site').forEach((cardProductionSiteEl, index) => {
        new Swiper(cardProductionSiteEl.querySelector('.production-site-gallery-slider'), {
            modules: [Navigation, Pagination],
            slidesPerView: 1,
            spaceBetween: 16,
            pagination: {
                el: cardProductionSiteEl.querySelector('.card-production-site-slider-pagination'),
                type: 'progressbar',
            },
            navigation: {
                nextEl: cardProductionSiteEl.querySelector('.card-production-site-slider-next'),
                prevEl: cardProductionSiteEl.querySelector('.card-production-site-slider-prev'),
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 18,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                },
                1200: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                },
            }
        });
    });
}










